import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import LandingPage from './Pages/LandingPage/LandingPage';
import ContactMe from './Pages/ContactMe/ContactMe';
import AddComments from './Pages/AddComments/AddComments';

function App() {

  useEffect(() => {
    window.onload = function () {
      alert("This website is currently under development. Thank you for your patience!");
    };
  },[])

  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<LandingPage />} />
        <Route path='contact' element={<ContactMe />} />
        <Route path='add-comment' element={<AddComments />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
